/** enforces maxChars on input-components that supports it. */
export const enforceMaxChars = false;

export const isDebugMode = false;
